<script setup lang="ts">
import { computed, ref, shallowRef, watchEffect } from 'vue'
import { DataRow, Table } from '../../types/components/data-rendering'
import { useStoreProfiles } from '../../store/useStoreProfiles'
import { storeToRefs } from 'pinia'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'

const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { getStores } = storeToRefs(useStoreProfiles())
    data.value = getStores.value
    loading.value = false
  },
  { flush: 'post' }
)
//settings for table
const displayOptions = computed(() => {
  return {
    route: { link: (row: DataRow) => `/stores/${row.store_id}` },
  }
})
</script>
<template>
  <FilteringDataDisplay
    :key="data"
    :enable-filters="true"
    :is-loading="loading"
    :table-data="data"
    :options="displayOptions"
  />
</template>
